import {IconButton} from '@wandb/components';
import {Icon} from '@wandb/weave/components/Icon';
import React, {useCallback} from 'react';

import {safeLocalStorage, useStorageChange} from '../../../util/localStorage';
import {Banner, BannerFlexWrapper} from './../../../components/Banner';

export const IssuesWelcomeBanner = () => {
  const [isDismissed, setIsDismissed] = React.useState(
    safeLocalStorage.getItem('run-issues-welcome-banner-dismissed') === 'true'
  );

  const handleStorageChange = useCallback((event: StorageEvent) => {
    if (event.key === 'run-issues-welcome-banner-dismissed') {
      setIsDismissed(event.newValue === 'true');
    }
  }, []);

  useStorageChange('run-issues-welcome-banner-dismissed', handleStorageChange);

  const handleDismiss = useCallback(() => {
    safeLocalStorage.setItem('run-issues-welcome-banner-dismissed', 'true');
    setIsDismissed(true);
  }, [setIsDismissed]);

  if (isDismissed) {
    return null;
  }

  return (
    <Banner>
      <BannerFlexWrapper>
        <Icon name="system-chip" className="h-24 w-24" />
        <div>
          <span className="text-[15px] font-semibold">
            Introducing issue observability for CoreWeave Cloud.
          </span>{' '}
          Automatically detect and surface system-level issues that occurred
          during your runs.
        </div>
        <IconButton
          aria-label="close"
          onClick={handleDismiss}
          icon="close"
          variant="ghost"
        />
      </BannerFlexWrapper>
    </Banner>
  );
};
